var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCertificateLeftGlow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 602,
    height: 600,
    viewBox: "0 0 602 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2253_4480)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.1343,
    height: 692.628,
    transform: "matrix(-0.181797 0.983336 0.985561 0.16932 -287.686 211.597)",
    fill: "url(#paint0_linear_2253_4480)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2253_4480)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.6561,
    height: 297.699,
    transform: "matrix(-0.181797 0.983336 0.985561 0.16932 -250.962 222.207)",
    fill: "url(#paint1_linear_2253_4480)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    opacity: 0.6
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M109.397 329.902C109.032 329.885 108.753 329.577 108.774 329.214C108.795 328.851 109.107 328.571 109.472 328.588C109.837 328.605 110.116 328.913 110.095 329.276C110.075 329.639 109.762 329.92 109.397 329.902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.049 333.413C106.775 333.4 106.566 333.169 106.582 332.897C106.597 332.624 106.832 332.414 107.105 332.427C107.379 332.44 107.588 332.671 107.572 332.943C107.557 333.216 107.323 333.426 107.049 333.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5431 326.004C96.2695 325.991 96.0604 325.76 96.0759 325.488C96.0915 325.215 96.3258 325.005 96.5994 325.018C96.873 325.031 97.0821 325.262 97.0666 325.534C97.051 325.806 96.8167 326.017 96.5431 326.004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.648 326.666C124.374 326.653 124.165 326.422 124.18 326.15C124.196 325.878 124.43 325.667 124.704 325.68C124.977 325.693 125.187 325.924 125.171 326.196C125.156 326.469 124.921 326.679 124.648 326.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M140.543 335.321C140.178 335.304 139.899 334.996 139.92 334.633C139.94 334.27 140.253 333.99 140.618 334.007C140.983 334.024 141.262 334.332 141.241 334.695C141.22 335.058 140.907 335.339 140.543 335.321Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.228 328.388C147.046 328.38 146.907 328.226 146.917 328.044C146.927 327.863 147.083 327.723 147.266 327.732C147.448 327.74 147.587 327.894 147.577 328.075C147.567 328.257 147.41 328.397 147.228 328.388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.659 342.761C109.477 342.753 109.337 342.599 109.348 342.417C109.358 342.236 109.514 342.096 109.696 342.105C109.879 342.113 110.018 342.267 110.008 342.449C109.997 342.63 109.841 342.77 109.659 342.761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6754 339.372C37.4931 339.364 37.3538 339.21 37.3641 339.028C37.3745 338.847 37.5307 338.707 37.7129 338.716C37.8952 338.724 38.0346 338.878 38.0242 339.06C38.0139 339.241 37.8577 339.381 37.6754 339.372Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.69788 319.934C2.5156 319.926 2.37625 319.772 2.38661 319.59C2.39697 319.409 2.55311 319.269 2.73539 319.277C2.91766 319.286 3.05703 319.44 3.04667 319.621C3.03632 319.803 2.88015 319.943 2.69788 319.934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.083 339.726C219.9 339.717 219.761 339.563 219.771 339.382C219.782 339.201 219.938 339.061 220.12 339.069C220.302 339.078 220.442 339.232 220.431 339.413C220.421 339.595 220.265 339.735 220.083 339.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M226.046 322.218C225.863 322.209 225.724 322.055 225.734 321.874C225.745 321.692 225.901 321.552 226.083 321.561C226.265 321.569 226.405 321.723 226.394 321.905C226.384 322.086 226.228 322.226 226.046 322.218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M239.811 330.443C239.629 330.435 239.49 330.281 239.5 330.1C239.51 329.918 239.666 329.778 239.849 329.787C240.031 329.795 240.17 329.949 240.16 330.131C240.15 330.312 239.993 330.452 239.811 330.443Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M227.79 349.644C227.607 349.635 227.468 349.481 227.478 349.3C227.489 349.119 227.645 348.979 227.827 348.987C228.009 348.996 228.149 349.15 228.138 349.331C228.128 349.512 227.972 349.653 227.79 349.644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M149.958 332.799C149.775 332.79 149.636 332.636 149.646 332.455C149.657 332.273 149.813 332.133 149.995 332.142C150.177 332.151 150.317 332.304 150.306 332.486C150.296 332.667 150.14 332.807 149.958 332.799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M109.64 354.622C109.458 354.614 109.319 354.46 109.329 354.278C109.339 354.097 109.496 353.957 109.678 353.965C109.86 353.974 109.999 354.128 109.989 354.309C109.979 354.491 109.823 354.631 109.64 354.622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M46.4332 348.35C46.251 348.341 46.1116 348.187 46.122 348.006C46.1323 347.824 46.2885 347.684 46.4707 347.693C46.653 347.702 46.7924 347.856 46.782 348.037C46.7717 348.218 46.6155 348.358 46.4332 348.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M205.361 330.798C205.179 330.789 205.039 330.635 205.05 330.454C205.06 330.272 205.216 330.132 205.398 330.141C205.581 330.149 205.72 330.303 205.71 330.485C205.699 330.666 205.543 330.806 205.361 330.798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.43 309.478C130.248 309.47 130.109 309.316 130.119 309.134C130.129 308.953 130.286 308.813 130.468 308.821C130.65 308.83 130.789 308.984 130.779 309.165C130.769 309.347 130.613 309.487 130.43 309.478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6188 306.427C79.4365 306.419 79.2971 306.265 79.3075 306.083C79.3179 305.902 79.474 305.762 79.6563 305.77C79.8386 305.779 79.9779 305.933 79.9676 306.114C79.9572 306.296 79.8011 306.436 79.6188 306.427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.158 340.763C150.976 340.754 150.836 340.6 150.847 340.419C150.857 340.238 151.013 340.097 151.195 340.106C151.378 340.115 151.517 340.269 151.507 340.45C151.496 340.631 151.34 340.771 151.158 340.763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M174.272 341.852C174.09 341.843 173.95 341.689 173.961 341.508C173.971 341.327 174.127 341.187 174.31 341.195C174.492 341.204 174.631 341.358 174.621 341.539C174.611 341.72 174.454 341.861 174.272 341.852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M202.506 322.757C202.324 322.749 202.185 322.595 202.195 322.413C202.206 322.232 202.362 322.092 202.544 322.1C202.726 322.109 202.866 322.263 202.855 322.444C202.845 322.626 202.689 322.766 202.506 322.757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M124.034 317.084C123.852 317.076 123.712 316.922 123.723 316.74C123.733 316.559 123.889 316.419 124.071 316.427C124.254 316.436 124.393 316.59 124.383 316.771C124.372 316.953 124.216 317.093 124.034 317.084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M145.186 346.742C145.004 346.734 144.865 346.58 144.875 346.398C144.885 346.217 145.041 346.077 145.224 346.086C145.406 346.094 145.545 346.248 145.535 346.429C145.525 346.611 145.368 346.751 145.186 346.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M184.953 351.908C184.77 351.9 184.631 351.746 184.641 351.564C184.652 351.383 184.808 351.243 184.99 351.252C185.173 351.26 185.312 351.414 185.302 351.595C185.291 351.777 185.135 351.917 184.953 351.908Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M195.784 330.348C195.602 330.339 195.462 330.185 195.473 330.004C195.483 329.822 195.639 329.682 195.821 329.691C196.004 329.699 196.143 329.853 196.133 330.035C196.122 330.216 195.966 330.356 195.784 330.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M44.3932 308.72C44.2109 308.712 44.0716 308.558 44.0819 308.376C44.0923 308.195 44.2484 308.055 44.4307 308.064C44.613 308.072 44.7523 308.226 44.742 308.407C44.7316 308.589 44.5755 308.729 44.3932 308.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M81.943 341.127C81.5781 341.11 81.2992 340.801 81.3199 340.438C81.3406 340.075 81.6532 339.795 82.0181 339.812C82.3829 339.829 82.6619 340.138 82.6412 340.501C82.6204 340.864 82.3078 341.144 81.943 341.127Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M63.0211 330.354C62.6562 330.336 62.3773 330.028 62.398 329.665C62.4187 329.302 62.7313 329.022 63.0962 329.039C63.461 329.056 63.74 329.364 63.7193 329.727C63.6986 330.09 63.386 330.371 63.0211 330.354Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8429 318.863C63.5693 318.85 63.3602 318.619 63.3757 318.347C63.3913 318.075 63.6256 317.864 63.8992 317.877C64.1728 317.89 64.3819 318.121 64.3664 318.394C64.3508 318.666 64.1165 318.876 63.8429 318.863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6554 354.435C84.3818 354.422 84.1726 354.191 84.1882 353.918C84.2037 353.646 84.4381 353.436 84.7117 353.449C84.9853 353.462 85.1944 353.693 85.1789 353.965C85.1633 354.237 84.929 354.447 84.6554 354.435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.273 360.348C188.999 360.336 188.79 360.104 188.805 359.832C188.821 359.56 189.055 359.35 189.329 359.363C189.602 359.376 189.812 359.607 189.796 359.879C189.781 360.151 189.546 360.361 189.273 360.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.616 354.861C233.343 354.848 233.134 354.617 233.149 354.345C233.165 354.073 233.399 353.862 233.673 353.875C233.946 353.888 234.155 354.119 234.14 354.392C234.124 354.664 233.89 354.874 233.616 354.861Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.981 341.983C239.707 341.97 239.498 341.739 239.513 341.467C239.529 341.195 239.763 340.984 240.037 340.997C240.31 341.01 240.52 341.241 240.504 341.513C240.489 341.786 240.254 341.996 239.981 341.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3156 326.181C79.042 326.168 78.8328 325.937 78.8484 325.665C78.8639 325.393 79.0983 325.182 79.3719 325.195C79.6454 325.208 79.8546 325.439 79.839 325.711C79.8235 325.984 79.5891 326.194 79.3156 326.181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.381 353.2C135.107 353.187 134.898 352.956 134.914 352.683C134.929 352.411 135.164 352.201 135.437 352.214C135.711 352.227 135.92 352.458 135.904 352.73C135.889 353.002 135.655 353.212 135.381 353.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3654 363.409C51.0918 363.397 50.8826 363.165 50.8982 362.893C50.9137 362.621 51.1481 362.411 51.4216 362.424C51.6952 362.437 51.9044 362.668 51.8888 362.94C51.8733 363.212 51.6389 363.422 51.3654 363.409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M36.5826 317.907C36.2178 317.89 35.9388 317.582 35.9595 317.219C35.9803 316.856 36.2929 316.575 36.6577 316.592C37.0226 316.61 37.3016 316.918 37.2808 317.281C37.2601 317.644 36.9475 317.924 36.5826 317.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9156 294.581C37.5508 294.564 37.2718 294.255 37.2925 293.892C37.3133 293.529 37.6259 293.249 37.9907 293.266C38.3556 293.283 38.6346 293.591 38.6138 293.954C38.5931 294.318 38.2805 294.598 37.9156 294.581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1642 324.336C18.8906 324.323 18.6814 324.092 18.697 323.82C18.7125 323.547 18.9469 323.337 19.2205 323.35C19.494 323.363 19.7032 323.594 19.6877 323.866C19.6721 324.138 19.4377 324.349 19.1642 324.336Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3.88146 310.768C3.5166 310.751 3.23763 310.443 3.25837 310.08C3.2791 309.717 3.59168 309.437 3.95654 309.454C4.3214 309.471 4.60038 309.779 4.57965 310.142C4.55891 310.505 4.24632 310.786 3.88146 310.768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M8.45665 335.03C8.09179 335.013 7.81283 334.705 7.83356 334.342C7.8543 333.979 8.16687 333.699 8.53173 333.716C8.89659 333.733 9.17557 334.041 9.15484 334.404C9.13411 334.767 8.82151 335.048 8.45665 335.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M197.668 349.542C197.303 349.524 197.024 349.216 197.045 348.853C197.065 348.49 197.378 348.21 197.743 348.227C198.108 348.244 198.387 348.552 198.366 348.915C198.345 349.278 198.032 349.559 197.668 349.542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M225.447 332.731C225.082 332.714 224.803 332.406 224.824 332.043C224.845 331.68 225.157 331.399 225.522 331.417C225.887 331.434 226.166 331.742 226.145 332.105C226.124 332.468 225.812 332.749 225.447 332.731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M178.867 319.338C178.502 319.32 178.223 319.012 178.244 318.649C178.264 318.286 178.577 318.006 178.942 318.023C179.307 318.04 179.586 318.348 179.565 318.711C179.544 319.074 179.232 319.355 178.867 319.338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M188.157 313.186C187.792 313.169 187.513 312.861 187.534 312.497C187.554 312.134 187.867 311.854 188.232 311.871C188.597 311.888 188.876 312.197 188.855 312.56C188.834 312.923 188.522 313.203 188.157 313.186Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M189.598 334.338C189.233 334.321 188.954 334.012 188.975 333.649C188.996 333.286 189.308 333.006 189.673 333.023C190.038 333.04 190.317 333.349 190.296 333.712C190.276 334.075 189.963 334.355 189.598 334.338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.982 333.037C168.708 333.025 168.499 332.793 168.514 332.521C168.53 332.249 168.764 332.039 169.038 332.052C169.311 332.065 169.521 332.296 169.505 332.568C169.49 332.84 169.255 333.05 168.982 333.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M0.940067 224.189C0.575207 224.171 0.296244 223.863 0.316977 223.5C0.337711 223.137 0.65029 222.857 1.01515 222.874C1.38001 222.891 1.65897 223.199 1.63824 223.562C1.61751 223.925 1.30493 224.206 0.940067 224.189Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1896 220.955C15.916 220.942 15.7068 220.711 15.7224 220.439C15.7379 220.166 15.9723 219.956 16.2459 219.969C16.5194 219.982 16.7286 220.213 16.7131 220.485C16.6975 220.758 16.4631 220.968 16.1896 220.955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M32.0846 229.61C31.7197 229.593 31.4408 229.285 31.4615 228.922C31.4822 228.559 31.7948 228.278 32.1597 228.295C32.5245 228.312 32.8035 228.621 32.7828 228.984C32.762 229.347 32.4494 229.627 32.0846 229.61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7692 222.677C38.5869 222.669 38.4475 222.515 38.4579 222.333C38.4682 222.152 38.6244 222.012 38.8067 222.02C38.989 222.029 39.1283 222.183 39.118 222.364C39.1076 222.546 38.9514 222.686 38.7692 222.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.20081 237.05C1.01853 237.041 0.879165 236.887 0.889522 236.706C0.89988 236.524 1.05604 236.384 1.23832 236.393C1.42059 236.401 1.55996 236.555 1.5496 236.737C1.53925 236.918 1.38308 237.058 1.20081 237.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.624 234.014C111.441 234.005 111.302 233.851 111.312 233.67C111.323 233.489 111.479 233.348 111.661 233.357C111.843 233.366 111.983 233.52 111.972 233.701C111.962 233.882 111.806 234.022 111.624 234.014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M117.588 216.506C117.405 216.498 117.266 216.344 117.276 216.162C117.287 215.981 117.443 215.841 117.625 215.849C117.807 215.858 117.947 216.012 117.936 216.193C117.926 216.375 117.77 216.515 117.588 216.506Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M131.353 224.732C131.171 224.723 131.032 224.569 131.042 224.388C131.052 224.207 131.208 224.066 131.391 224.075C131.573 224.084 131.712 224.238 131.702 224.419C131.692 224.6 131.535 224.74 131.353 224.732Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M119.332 243.932C119.149 243.923 119.01 243.769 119.02 243.588C119.031 243.406 119.187 243.266 119.369 243.275C119.551 243.284 119.691 243.438 119.68 243.619C119.67 243.8 119.514 243.94 119.332 243.932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M41.4987 227.086C41.3164 227.078 41.177 226.924 41.1874 226.742C41.1977 226.561 41.3539 226.421 41.5362 226.43C41.7185 226.438 41.8578 226.592 41.8475 226.773C41.8371 226.955 41.6809 227.095 41.4987 227.086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M1.18225 248.911C0.99998 248.902 0.860611 248.748 0.870969 248.567C0.881327 248.385 1.03749 248.245 1.21976 248.254C1.40204 248.262 1.54141 248.416 1.53105 248.598C1.52069 248.779 1.36453 248.919 1.18225 248.911Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M96.902 225.085C96.7197 225.077 96.5803 224.923 96.5907 224.741C96.6011 224.56 96.7572 224.42 96.9395 224.428C97.1218 224.437 97.2611 224.591 97.2508 224.772C97.2404 224.954 97.0843 225.094 96.902 225.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9723 203.766C21.79 203.757 21.6507 203.603 21.661 203.422C21.6714 203.24 21.8275 203.1 22.0098 203.109C22.1921 203.117 22.3314 203.271 22.3211 203.453C22.3107 203.634 22.1546 203.774 21.9723 203.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6998 235.051C42.5176 235.043 42.3782 234.889 42.3886 234.707C42.3989 234.526 42.5551 234.386 42.7374 234.395C42.9196 234.403 43.059 234.557 43.0486 234.739C43.0383 234.92 42.8821 235.06 42.6998 235.051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M65.8131 236.14C65.6308 236.131 65.4915 235.977 65.5018 235.796C65.5122 235.614 65.6684 235.474 65.8506 235.483C66.0329 235.492 66.1723 235.646 66.1619 235.827C66.1516 236.008 65.9954 236.148 65.8131 236.14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M94.0485 217.046C93.8662 217.037 93.7268 216.883 93.7372 216.702C93.7475 216.52 93.9037 216.38 94.086 216.389C94.2683 216.397 94.4076 216.551 94.3973 216.733C94.3869 216.914 94.2307 217.054 94.0485 217.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M15.5758 211.373C15.3935 211.364 15.2542 211.21 15.2645 211.029C15.2749 210.848 15.431 210.708 15.6133 210.716C15.7956 210.725 15.935 210.879 15.9246 211.06C15.9142 211.241 15.7581 211.382 15.5758 211.373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M36.7272 241.029C36.5449 241.021 36.4055 240.867 36.4159 240.685C36.4262 240.504 36.5824 240.364 36.7647 240.373C36.947 240.381 37.0863 240.535 37.076 240.717C37.0656 240.898 36.9095 241.038 36.7272 241.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M76.4948 246.197C76.3125 246.188 76.1731 246.034 76.1835 245.853C76.1938 245.671 76.35 245.531 76.5323 245.54C76.7145 245.548 76.8539 245.702 76.8436 245.884C76.8332 246.065 76.677 246.205 76.4948 246.197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M87.3268 224.636C87.1445 224.627 87.0051 224.473 87.0155 224.292C87.0259 224.111 87.182 223.97 87.3643 223.979C87.5466 223.988 87.6859 224.142 87.6756 224.323C87.6652 224.504 87.5091 224.644 87.3268 224.636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8136 254.636C80.54 254.623 80.3309 254.392 80.3464 254.12C80.362 253.847 80.5963 253.637 80.8699 253.65C81.1435 253.663 81.3526 253.894 81.3371 254.166C81.3215 254.438 81.0872 254.649 80.8136 254.636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.157 249.149C124.884 249.136 124.675 248.905 124.69 248.632C124.706 248.36 124.94 248.15 125.214 248.163C125.487 248.176 125.696 248.407 125.681 248.679C125.665 248.951 125.431 249.162 125.157 249.149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.523 236.27C131.249 236.257 131.04 236.026 131.055 235.754C131.071 235.482 131.305 235.272 131.579 235.285C131.852 235.297 132.062 235.529 132.046 235.801C132.031 236.073 131.796 236.283 131.523 236.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.923 247.487C26.6494 247.474 26.4402 247.243 26.4558 246.971C26.4713 246.698 26.7057 246.488 26.9793 246.501C27.2528 246.514 27.462 246.745 27.4465 247.017C27.4309 247.29 27.1965 247.5 26.923 247.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M89.2096 243.83C88.8447 243.813 88.5658 243.505 88.5865 243.142C88.6072 242.779 88.9198 242.498 89.2847 242.516C89.6495 242.533 89.9285 242.841 89.9078 243.204C89.887 243.567 89.5745 243.847 89.2096 243.83Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M116.991 227.019C116.626 227.002 116.347 226.693 116.368 226.33C116.388 225.967 116.701 225.687 117.066 225.704C117.431 225.721 117.71 226.029 117.689 226.392C117.668 226.756 117.356 227.036 116.991 227.019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M70.4108 213.625C70.0459 213.607 69.7669 213.299 69.7877 212.936C69.8084 212.573 70.121 212.293 70.4858 212.31C70.8507 212.327 71.1297 212.635 71.1089 212.998C71.0882 213.361 70.7756 213.642 70.4108 213.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M79.7018 207.473C79.3369 207.456 79.058 207.148 79.0787 206.785C79.0994 206.422 79.412 206.141 79.7769 206.158C80.1417 206.176 80.4207 206.484 80.4 206.847C80.3792 207.21 80.0666 207.49 79.7018 207.473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M81.1383 228.626C80.7734 228.609 80.4945 228.301 80.5152 227.938C80.5359 227.575 80.8485 227.294 81.2134 227.311C81.5782 227.329 81.8572 227.637 81.8365 228C81.8157 228.363 81.5032 228.643 81.1383 228.626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5216 227.325C60.248 227.312 60.0389 227.081 60.0544 226.809C60.07 226.537 60.3043 226.326 60.5779 226.339C60.8515 226.352 61.0606 226.583 61.0451 226.855C61.0295 227.128 60.7952 227.338 60.5216 227.325Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2253_4480",
    x: -470.409,
    y: 34.8969,
    width: 1042.05,
    height: 503.258,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 88.35,
    result: "effect1_foregroundBlur_2253_4480"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2253_4480",
    x: -375.444,
    y: 102.207,
    width: 537.884,
    height: 314.652,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60,
    result: "effect1_foregroundBlur_2253_4480"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2253_4480",
    x1: 16.5671,
    y1: 0,
    x2: 16.5671,
    y2: 692.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59E0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2253_4480",
    x1: 12.328,
    y1: 0,
    x2: 12.328,
    y2: 297.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59E0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateLeftGlow);
export default __webpack_public_path__ + "static/media/certificate-left-glow.aaa51a2cc2231dee872f43f992a7bd8d.svg";
export { ForwardRef as ReactComponent };